// extracted by mini-css-extract-plugin
module.exports = {"button":"MainButton_button__UKLaa","primary":"MainButton_primary__lx6D4","secondary":"MainButton_secondary__dr_j2","info":"MainButton_info__t_0vC"};